module.exports = __webpack_public_path__ + "img/cutdownPriceButton@2x.882ad3a2.png";